var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-container",
          attrs: {
            visible: _vm.addDialog,
            title: _vm.title,
            width: "60%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
            "update:title": function ($event) {
              _vm.title = $event
            },
            closed: _vm.handleCancel,
            opened: _vm.beforeOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFrom",
              attrs: {
                model: _vm.addFrom,
                rules: _vm.addRules,
                "label-width": "120px",
                "validate-on-rule-change": false,
              },
            },
            [
              _c(
                "el-collapse",
                {
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { title: "会员类型-类别配置", name: "1" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "type", label: "会员类别" } },
                        _vm._l(_vm.type, function (item) {
                          return _c(
                            "el-radio",
                            {
                              key: item.value,
                              attrs: {
                                disabled: _vm.title === "编辑会员类型",
                                label: item.value,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.fixValidate("type")
                                },
                              },
                              model: {
                                value: _vm.addFrom.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addFrom, "type", $$v)
                                },
                                expression: "addFrom.type",
                              },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员等级", prop: "level" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择会员等级" },
                              on: {
                                change: function ($event) {
                                  return _vm.fixValidate("level")
                                },
                              },
                              model: {
                                value: _vm.addFrom.level,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addFrom, "level", $$v)
                                },
                                expression: "addFrom.level",
                              },
                            },
                            _vm._l(_vm.level, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "权重等级", prop: "weightLevel" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "210px",
                                  "margin-right": "10px",
                                },
                                attrs: { placeholder: "正整数输入" },
                                model: {
                                  value: _vm.addFrom.weightLevel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addFrom, "weightLevel", $$v)
                                  },
                                  expression: "addFrom.weightLevel",
                                },
                              }),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "数字越大权重越高，同等级下，优先消耗权重高的类型权益",
                                    placement: "right",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-info" })]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "售卖状态", prop: "sellStatus" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeSellStatus },
                              model: {
                                value: _vm.addFrom.sellStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addFrom, "sellStatus", $$v)
                                },
                                expression: "addFrom.sellStatus",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("在售"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("停售"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "用户身份", prop: "memberIdentity" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.title === "编辑会员类型" },
                              model: {
                                value: _vm.addFrom.memberIdentity,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addFrom, "memberIdentity", $$v)
                                },
                                expression: "addFrom.memberIdentity",
                              },
                            },
                            _vm._l(_vm.memberIdentity, function (item) {
                              return _c(
                                "el-popover",
                                {
                                  key: item.value,
                                  attrs: {
                                    width: "400",
                                    placement: "top-start",
                                    trigger: "hover",
                                    content: item.content,
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { "margin-right": "20px" },
                                      attrs: {
                                        slot: "reference",
                                        label: item.value,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.fixValidate(
                                            "memberIdentity"
                                          )
                                        },
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { title: "会员类型-基础配置", name: "2" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员类型名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 10 },
                              width: "40%",
                              maxlength: "99",
                              "show-word-limit": "",
                              placeholder: "请输入会员类型名称",
                            },
                            model: {
                              value: _vm.addFrom.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.addFrom, "name", $$v)
                              },
                              expression: "addFrom.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员图标", prop: "icon" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-items": "center",
                                "align-items": "center",
                              },
                            },
                            [
                              _vm.addFrom.icon
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "100px",
                                      height: "100px",
                                      "margin-right": "10px",
                                    },
                                    attrs: {
                                      fit: "scale-down",
                                      src: _vm.addFrom.icon,
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "el-upload",
                                {
                                  staticClass: "upload-demo",
                                  attrs: {
                                    "before-upload": _vm.checkUpload,
                                    "http-request": _vm.upload,
                                    listType: "picture-img",
                                    "on-preview": _vm.handlePreview,
                                    "on-remove": _vm.handleRemove,
                                    "before-remove": _vm.beforeRemove,
                                    "on-exceed": _vm.handleExceed,
                                    "show-file-list": false,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { size: "small" } },
                                    [_vm._v("上传会员图标")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型描述", prop: "description" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 99 },
                              width: "40%",
                              maxlength: "999",
                              "show-word-limit": "",
                              placeholder: "请输入会员类型描述",
                            },
                            model: {
                              value: _vm.addFrom.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.addFrom, "description", $$v)
                              },
                              expression: "addFrom.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.addFrom.memberIdentity === "2"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "刊例价格",
                                prop: "publishPrice",
                              },
                            },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    width: "400",
                                    placement: "top-start",
                                    trigger: "hover",
                                    content:
                                      "会员升级时取自此字段的价格数值，按照单日的刊例价格来计算",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { display: "flex" },
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "30%",
                                          "margin-right": "10px",
                                        },
                                        attrs: { placeholder: "请输入价格" },
                                        model: {
                                          value: _vm.addFrom.publishPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.addFrom,
                                              "publishPrice",
                                              $$v
                                            )
                                          },
                                          expression: "addFrom.publishPrice",
                                        },
                                      }),
                                      _vm._v("元/日\n              "),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { title: "会员类型-权益配置", name: "3" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户端类型", prop: "clientTypes" } },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                width: "400",
                                placement: "top-start",
                                trigger: "hover",
                                content:
                                  "配置逻辑是给哪些客户端配置哪些会员权益，可针对不同的客户端配置不同的权益",
                              },
                            },
                            [
                              _c("el-cascader-panel", {
                                ref: "clientTypesSelect",
                                staticStyle: { width: "400px" },
                                attrs: {
                                  slot: "reference",
                                  options: _vm.clientSelectList,
                                  props: { multiple: true },
                                },
                                on: { change: _vm.selectChange },
                                slot: "reference",
                                model: {
                                  value: _vm.clientSelect,
                                  callback: function ($$v) {
                                    _vm.clientSelect = $$v
                                  },
                                  expression: "clientSelect",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "权益项集",
                            prop: "memberTypeRightsItems",
                          },
                        },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                width: "400",
                                placement: "top-start",
                                trigger: "hover",
                                content:
                                  "代表所有选择的权益（不区分端）的集合\n            若在权益管理处配置某项权益携带限制参数，则会在下方显示参数配置",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                _vm._l(
                                  _vm.memberTypeRightsItems,
                                  function (item) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: item.label,
                                        staticStyle: { "margin-right": "10px" },
                                        attrs: {
                                          closable: "",
                                          "disable-transitions": false,
                                        },
                                        on: {
                                          close: function ($event) {
                                            return _vm.handleCloseTag(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.label) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._l(
                        _vm.addFrom.newMemberTypeRightsItems,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "memberType_newMemberTypeRightsItems_container",
                              staticStyle: {
                                "padding-left": "50px",
                                "background-color": "#eff0f3",
                              },
                            },
                            [
                              item.limitParams &&
                              _vm.filterLimitParams(item.value)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "memberType_newMemberTypeRightsItems_box",
                                      staticStyle: {
                                        display: "flex",
                                        "margin-bottom": "10px",
                                      },
                                    },
                                    [
                                      item.limitParams.length > 0 &&
                                      item.limitParams[0].code
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "memberType_newMemberTypeRightsItems_label",
                                              staticStyle: {
                                                width: "15%",
                                                padding: "20px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.label) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "memberType_newMemberTypeRightsItems_box_content",
                                          staticStyle: { flex: "1" },
                                        },
                                        _vm._l(
                                          item.limitParams,
                                          function (ele, childIndex) {
                                            return _c(
                                              "el-form-item",
                                              {
                                                key: ele.code,
                                                staticClass:
                                                  "memberType_newMemberTypeRightsItems",
                                                attrs: {
                                                  prop: `newMemberTypeRightsItems.${index}.limitParams.${childIndex}.inputValue`,
                                                },
                                              },
                                              [
                                                ele.code
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          "justify-items":
                                                            "center",
                                                          "align-items":
                                                            "center",
                                                          "justify-content":
                                                            "flex-start",
                                                          "margin-left":
                                                            "-65px",
                                                          padding:
                                                            "10px 0 20px 0",
                                                        },
                                                      },
                                                      [
                                                        ele.code
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "20px",
                                                                  width: "25%",
                                                                  color:
                                                                    "#6c6c6c",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      ele.desc
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        ele.code
                                                          ? _c("el-input", {
                                                              staticStyle: {
                                                                width: "50%",
                                                              },
                                                              attrs: {
                                                                placeholder:
                                                                  ele.remark,
                                                              },
                                                              model: {
                                                                value:
                                                                  ele.inputValue,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      ele,
                                                                      "inputValue",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ele.inputValue",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型状态", prop: "state" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.addFrom.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addFrom, "state", $$v)
                                },
                                expression: "addFrom.state",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("启用"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("禁用"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 10000 },
                              width: "40%",
                              maxlength: "9999",
                              "show-word-limit": "",
                              placeholder: "请输入备注",
                            },
                            model: {
                              value: _vm.addFrom.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.addFrom, "remark", $$v)
                              },
                              expression: "addFrom.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: `在售的类型`,
                visible: _vm.sellStatusConfirmVisible,
                width: "30%",
                "append-to-body": true,
                "before-close": _vm.handleSellStatusCancel,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.sellStatusConfirmVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "sellVipTypeContainer" },
                [
                  _c("div", [
                    _vm._v("当前会员类别下的会员等级在售的会员类型有："),
                  ]),
                  _vm.addFrom.sellVipType && _vm.addFrom.sellVipType.length > 0
                    ? _vm._l(_vm.addFrom.sellVipType, function (item) {
                        return _c(
                          "div",
                          { key: item.value, staticClass: "sellVipType" },
                          [
                            _vm._v(
                              "\n            (" +
                                _vm._s(item.value) +
                                ") " +
                                _vm._s(item.label) +
                                "\n          "
                            ),
                          ]
                        )
                      })
                    : [
                        _c("div", { staticClass: "noSellVipType" }, [
                          _vm._v("当前会员类别下的会员等级暂无在售的会员类型"),
                        ]),
                      ],
                ],
                2
              ),
              _c("div", { staticClass: "sellVipTypeContainer" }, [
                _vm._v("\n        操作“在售”后，需注意："),
                _c("br"),
                _vm._v("\n        1、该配置审批生效后，同等级其余会员类型状态"),
                _c("span", { staticStyle: { color: "#ff4040" } }, [
                  _vm._v("自动变更为“停售”"),
                ]),
                _c("br"),
                _vm._v(
                  "\n        2、在售状态不影响商品 SKU 是否可购买，运营需配合手动"
                ),
                _c("span", { staticStyle: { color: "#296df3" } }, [
                  _vm._v("下掉对应的停售类型下的会员商品"),
                ]),
                _vm._v(" 及 "),
                _c("span", { staticStyle: { color: "#296df3" } }, [
                  _vm._v("更改“支付页”配置"),
                ]),
                _c("br"),
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: { "text-align": "center" },
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSellStatusConfirm },
                    },
                    [_vm._v("确认，更改为“在售”状态")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }